import React, { useEffect, useState } from "react";
import "./PaymentdetailPage.css";
import paypal_round from "./../../../assets/cash-on-delivery.png";
import Bank from "./../../../assets/bank.png";
import CreditCard from "./../../../assets/credit-card.png";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { getPlaceorderapiRequest } from "../util/order";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoaderPage from "../../loader/components/LoaderPage";
import { getorderNotificationRequest } from "../util/sendOrderNotification";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { check } from "../../comman/components/CommonimagePath";
import { CART_DETAIL, CART_ITEM_DELETE } from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import BannercartPage from "../../comman/components/BannercartPage";
import {CurrentorderlistPage, OrdersummaryPage} from "../../comman/components/CurrentorderlistPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { maintainCartdata } from "../../home/redux/actions";
import { getRequestcall } from "../../comman/util/getRequest";
const PaymentSuccessPage = React.lazy(() =>
  import("../../modal/components/PaymentSuccessPage")
);


function PaymentdetailPage(props) {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [Select, setSelect] = useState(0);
  const [paymentsuccess, setPaymentsuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [paymenttype, setPaymenttype] = useState("");

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.payment_detail.title"), "", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.language]);
  useEffect(()=>{
    getCartDetailsAPI();
    // eslint-disable-next-line
  },[]);

  async function getCartDetailsAPI() {
    let response = await getRequestcall(CART_DETAIL + `?lang=${props?.language?.toLowerCase()}`, props?.access_token);
    if (response?.status === 200) {
      const result = await response?.json();
      const OutOfStock = result?.data?.cart_products?.filter((item) => item?.out_of_stock !== false);
      if (OutOfStock?.length > 0 || result?.data?.cart_products?.length === 0) {
        window.history.replaceState({}, document.title)
        navigate("/cart");
      }
    }
  }
  const orderPlace = async (pay_method) => {
    if (pay_method === "") {
      toast.error(t("pages.Please select available payment methods"));
    } else {
      let cartproducts = {};
      let cartproductslist = [];
      props?.cartdata?.forEach((item) => {
        if (
          item?.product_deleted_at === null &&
          item.variation_deleted_at === null &&
          item?.out_of_stock === false
        ) {
          cartproducts = {
            cart_id: item?.id,
            product_id: item?.product_id,
            product_variation_id: item?.variation_id,
          };
          cartproductslist.push(cartproducts);
        }
      });
      let getaddress =
        location?.state?.cardInput?.flat +
        ", " +
        location?.state?.cardInput?.street +
        ", " +
        location?.state?.cardInput?.address +
        ", " +
        location?.state?.cardInput?.postcode;
      let orderData = {
        order_delivery_type:
          typeof props?.amount?.order_delivery_type === "undefined"
            ? ""
            : props?.amount?.order_delivery_type,
        buyer_address_id: "",
        address: getaddress,
        lat: location?.state?.cardInput?.lat,
        lng: location?.state?.cardInput?.lng,
        slot: "",
        order_status: "Accepted",
        products: cartproductslist,
        payment_method: pay_method,
        payment_status: "Unpaid",
        store_id: props?.cartdata[0]?.store_id,
        coupon_code:
          typeof props?.amount?.coupon_code === "undefined"
            ? ""
            : props?.amount?.coupon_code,
        offer_id:
          typeof props?.amount?.offer_id === "undefined"
            ? ""
            : props?.amount?.offer_id,
        contact: location?.state?.cardInput?.phone,
        country_code: location?.state?.cardInput?.country_code,
        email: location?.state?.cardInput?.email,
      };
      setLoader(true);
      let getPlaceorderapiResponse = await getPlaceorderapiRequest(
        props.access_token,
        orderData,
        props?.language?.toLowerCase()
      );
      if (getPlaceorderapiResponse?.status === 200) {
        let getOrderid = await getPlaceorderapiResponse.json();
        toast.success(t("pages.payment_detail.success"));
        setLoader(false);
        setPaymentsuccess(true);
        callSendOrdernotification(getOrderid?.data?.id);
      } 
      else if(getPlaceorderapiResponse.status === 400) {
        let getErrormsg = await getPlaceorderapiResponse.json();
        toast.error(getErrormsg?.errors);
        props.maintainCartdata([], {});
        setLoader(false);
        navigate("/")
     }
      else if (getPlaceorderapiResponse.status === 500) {
        setLoader(false);
        toast.error(t("pages.internal"));
      }
    }
  };

  const callSendOrdernotification = async (order_id) => {
    let getdata = await getorderNotificationRequest(
      props.access_token,
      order_id,
      props?.language?.toLowerCase()
    );
    if (getdata?.status === 200) {
      await cartClear();
    }
  };

  // If product unavailable or out of stock then delete from cart
  const cartClear = async () => {
    props?.cartdata?.forEach(async (item) => {
      if (
        item?.product_deleted_at === null &&
        item.variation_deleted_at === null &&
        item?.out_of_stock === false
      ) {
      } else {
        let geturl = CART_ITEM_DELETE + `?id=${item.id}`;
        await postRequestcall(geturl, props?.access_token, "");
      }
    });
  };

  // On the selection of payment method order will place
  const selectionPaymentmethod = (value) => {
    setSelect(value);
    if (value === 1) {
      orderPlace("Credit or Debit");
      setPaymenttype("Credit or Debit");
    } else if (value === 2) {
      orderPlace("Online bank transfer");
      setPaymenttype("Online bank transfer");
    } else {
      orderPlace("COD");
      setPaymenttype("COD");
    }
  };

  const Paymentbutton = (props) => {
    return (
      <div className=" mb-3">
      <label
        htmlFor={"credit_card"}
        className={props?.select === 1 ? "card select" : "card"}
      >
        <div className="card-body">
          <LazyLoadImage alt="" src={props?.image} />
          <label htmlFor={"credit_card"}>
            {t("pages.payment_detail.credit_card")}
          </label>
        </div>
        <div className={"Select_icon"}>
          <img src={check} height="20" width="20" alt="select"></img>
        </div>
      </label>
      <input
        checked={props?.select === 1 ? true : false}
        onChange={() => selectionPaymentmethod(props?.select)}
        id={"credit_card"}
        name={"payment_type"}
        type={"radio"}
      />
    </div>
    )
  }


  if (loader) return (
    <div className="opacity-spinner">
      <LoaderPage className={"user-dashboard"} />
    </div>
  );

  return (
    <aside className="payment-detail">
      <BannercartPage title={"pages.payment_detail.title"}/>
      <div className="container pt-4 pb-4 mb-5">
        <div className="row">
          <div className="col-xl-9 mt-3 order-card">
            <div className="card">
              <div className="card-body">
                <h5 className="header-title pr-color">
                  {t("pages.payment_detail.subtitle")}
                </h5>
                <div className="card-type col-12 mt-3">
                  <Paymentbutton select={Select} image={CreditCard} title={"pages.payment_detail.credit_card"}/>
                  <Paymentbutton select={Select} image={Bank} title={"pages.payment_detail.bank"}/>
                  <Paymentbutton select={Select} image={paypal_round} title={"pages.Cash On Delivery"}/>
                </div>
                <div
                  className="hover mt-4"
                  onClick={() => navigate("/checkout")}
                >
                  {t("pages.payment_detail.back")}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mt-3">
            <div className="order-card">
             <CurrentorderlistPage cartdata={props?.cartdata} />
             <OrdersummaryPage amount={props?.amount}/>
              <div className="mt-4">
              <ButtonPage Text={t("pages.payment_detail.submit") 
              + " " + Number(
                typeof props?.amount?.total_amount === "undefined"
                  ? "00.00"
                  : props?.amount?.total_amount +
                      (typeof props?.amount?.charges === "undefined"
                        ? 0
                        : props?.amount?.charges) -
                      (typeof props?.amount?.discount === "undefined"
                        ? 0
                        : props?.amount?.discount)
              ).toFixed(2) + process.env.REACT_APP_CURRENCY_SYMBOL}  onClick={() => orderPlace("")} className={`button-submit w-100 rounded`} type={"submit"} /> 
              </div>
            </div>
          </div>
        </div>
      </div>
      {paymentsuccess && (
        <PaymentSuccessPage
          paymentsuccess={paymentsuccess}
          setPaymentsuccess={setPaymentsuccess}
          paymenttype={paymenttype}
        />
      )}
    </aside>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  language: state?.languageState?.language,
});
export default connect(mapStateToProps, { fetchHeaderContent,maintainCartdata })(
  PaymentdetailPage
);
